import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs';

// Shared driver for any section using the "Swiper" mobile layout (see
// snippets/mobile-grid-style.liquid's `real_swiper` param) - a section only
// needs a [data-mobile-swiper] wrapper around its <ul>/<li> grid, naming its
// own classes via data-grid-class/data-item-class. Swiper is mobile-only
// (desktop keeps the section's real CSS grid), so the instance is created
// and destroyed as the viewport crosses the 768px breakpoint rather than
// left running at all sizes.
function initMobileSwipers() {
  document.querySelectorAll('[data-mobile-swiper]').forEach(($carousel) => {
    const gridClass = $carousel.dataset.gridClass;
    const itemClass = $carousel.dataset.itemClass;
    if (!gridClass || !itemClass) return;

    const $wrapper = $carousel.querySelector('.' + gridClass);
    if (!$wrapper) return;

    const slideCount = $wrapper.querySelectorAll('.' + itemClass).length;
    if (slideCount < 2) return;

    const mobileQuery = window.matchMedia('(max-width: 767px)');

    function create() {
      if ($carousel.swiper) return;
      new Swiper($carousel, {
        wrapperClass: gridClass,
        slideClass: itemClass,
        slidesPerView: 'auto',
        spaceBetween: 24,
        slidesOffsetBefore: 16,
        grabCursor: true,
        watchOverflow: true,
      });
    }

    function destroy() {
      if ($carousel.swiper) {
        $carousel.swiper.destroy(true, true);
      }
    }

    function sync() {
      if (mobileQuery.matches) {
        create();
      } else {
        destroy();
      }
    }

    sync();
    mobileQuery.addEventListener('change', sync);
  });
}

initMobileSwipers();

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initMobileSwipers);
}
